import clsx from 'clsx';

export const mapContainerStyles = () =>
  clsx(
    "overflow-hidden",
    "pb-72",
    "relative",
    "h-0"
  )

export const mapIframeStyles = () =>
  clsx(
    "l-0",
    "t-0",
    "h-full",
    "w-full",
    "absolute",
  )
